import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { MULTIPLE } from './threadRemovalTypes';
const MultipleRemoval = Record({
  [THREAD_REMOVAL_TYPE]: MULTIPLE,
  audit: null,
  changes: List(),
  members: List()
}, 'MultipleRemoval');
export default MultipleRemoval;